var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:{ image: true, fadein: _vm.loaded, loading: !_vm.loaded },attrs:{"src":_vm.imagePath,"alt":"image","draggable":"false"}})}
var staticRenderFns = []

export { render, staticRenderFns }